<template>

<div class="row">

  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-3">
    <label for="category" class="form-label">Mês:</label>
    <input
      id="basicCalendar"
      type="text"
      class="form-control datepicker"
      placeholder="Selecione a data"
    />
  </div>

  <div class="header-left-side justify-content-center justify-content-md-start d-flex flex-column col-12 col-sm-3 mb-20">
    <label for="category" class="form-label">Atendente:</label>
    <select v-model="user_id" class="form-select" :disabled="!getUsers.length" @change="changeAttendant">
      <option value="">Todos os atendentes</option>
      <option v-for="user in getUsers" :key="user.id" :value="user.id">
        {{ user.name }}
      </option>
    </select>
  </div>
</div>

  <div class="row">
    <div class="col-12">
      <CardsPerformance />
    </div>
    <div class="col-xxl-12">
      <RankingPerformanceAttendants />
    </div>
  </div>
</template>

<script>

import { defineComponent } from "vue";
import RankingPerformanceAttendants from "../../components/Performance/RankingPerformanceAttendants.vue";
import CardsPerformance from "../../components/Performance/CardsPerformance.vue";
import { mapGetters, mapActions } from 'vuex';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

export default defineComponent({
  name: "PerformancePage",
  data(){
    return {
      search_date: null,
      user_id: "",
      fp: null
    }
  },
  components: {
    RankingPerformanceAttendants,
    CardsPerformance
  },
  computed: {
    ...mapGetters([
      "getUsers"
    ])
  },
  methods: {
    ...mapActions([
      "fetchPerformanceData",
      "fetchUsers"
    ]),
    changeAttendant(){
      let month, year;

      if (this.search_date) {

        const date = this.search_date.split('/');
        month = date[0];
        year  = date[1];

      } else {

        const now = new Date();
        month = String(now.getMonth() + 1).padStart(2, '0');
        year  = String(now.getFullYear());

      }

      this.fetchPerformanceData({ month, year, user_id: this.user_id != '' && this.user_id != null ? this.user_id : null });
    }
  },
  mounted() {

  const now = new Date();
  const month = now.getMonth(); // ⚠️ zero-based
  const year  = now.getFullYear();

  this.search_date = `${String(month + 1).padStart(2, '0')}/${year}`;
  this.fp = flatpickr("#basicCalendar", {
    locale: Portuguese,
    altInput: true,

    // 🔥 FORMATOS NO ROOT
    dateFormat: "m/Y",
    altFormat: "F Y",

    plugins: [
      new monthSelectPlugin({
        shorthand: true,
        theme: "dark"
      })
    ],

    onReady: (selectedDates, dateStr, instance) => {
      // ✅ PASSE UM DATE REAL
      instance.setDate(new Date(year, month, 1), true);
    },

    onChange: (selectedDates) => {
      const date = selectedDates[0];

      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year  = date.getFullYear();

      this.search_date = `${month}/${year}`;

      this.fetchPerformanceData({
        month,
        year,
        user_id: this.user_id || null
      });
    }
  });

  this.fetchUsers();
}


});
</script>